import { Department } from 'acscp/api/models/customTypes/department';

function migrateEnLocale(appState: any): any {
    // Previously the only supported language was English and this
    // was stored as 'en'. This is now split into en-GB and en-US,
    // so we have to update the stored value.
    if (appState && appState.intl && appState.intl.locale === 'en') {
        appState.intl.locale = 'en-GB';
    }
    return appState;
}

function migration_introduceGiftCategories(appState: any): any {
    // Previously gift categories did not exist
    if (appState && appState.gifts && !appState.gifts.giftCategories) {
        appState.gifts.giftCategories = [];
    }
    return appState;
}

function migration_quoteNameToQuoteOrder(appState: any): any {
    if (appState && appState.quotes && appState.quotes.quotesList
        && Object.keys(appState.quotes.quotesList).length > 0
        && !appState.quotes.quotesList[Object.keys(appState.quotes.quotesList)[0]].order) {
            Object.keys(appState.quotes.quotesList).forEach(id =>
                appState.quotes.quotesList[id].order = parseInt(appState.quotes.quotesList[id].name, 10)
            );
    }
    return appState;
}

function migration_clearOutOldReadState(appState: any): any {
    if (appState && appState.bookingsReadDetails) {
        const readStateValues =
            Object.keys(appState.bookingsReadDetails).map(key => appState.bookingsReadDetails[key]);
        if (readStateValues.some(value => !!value && value.version !== undefined)) {

            // Reset read state to nothing - we don't know booking's content identifiers,
            // so we can only remove invalid data and wait to receive up-to-date information on next fetch.
            appState.bookingReadDetails = {};
        }
    }

    return appState;
}

// As department on a quote was introduced with COMMJ it's safe to assume a quote without department will be PJETS
function migration_setQuoteInfo(appState: any): any {
    if (appState && appState.quotes && appState.quotes.quotesList
        && Object.keys(appState.quotes.quotesList).length > 0) {
        Object.keys(appState.quotes.quotesList).forEach(id => {
                if (!appState.quotes.quotesList[id].department) {
                    appState.quotes.quotesList[id].department = Department.PJETS;
                }
                if (!appState.quotes.quotesList[id].trips) {
                    appState.quotes.quotesList[id].trips = [];
                }
            }
        );
    }
    return appState;
}

// As department on a booking was introduced with COMMJ it's safe to assume a booking without department will be PJETS
function migration_setBookingDepartment(appState: any): any {
    if (appState && appState.bookingsDetails && appState.bookingsDetails.bookingsList
        && Object.keys(appState.bookingsDetails.bookingsList).length > 0
        && !appState.bookingsDetails.bookingList[Object.keys(appState.bookingsDetails.bookingList)[0]].departmentKey) {
        Object.keys(appState.bookingsDetails.bookingsList).forEach(id => {
            appState.bookingsDetails.bookingsList[id].departmentKey = Department.PJETS;
        });
    }
    return appState;
}

// Previously SetBySharingLink had a precedence of 10, but now it is 17 so that it overrides SetByUserDetails
function migrateLanguageStatePrecedence(appState: any): any {
    if (appState && appState.intl && appState.intl.languageState === 10) {
        appState.intl.languageState = 17;
    }
    return appState;
}

const migrations = [
    migrateEnLocale,
    migration_introduceGiftCategories,
    migration_quoteNameToQuoteOrder,
    migration_clearOutOldReadState,
    migration_setQuoteInfo,
    migration_setBookingDepartment,
    migrateLanguageStatePrecedence
];

export function migrateState(appState: any): any {
    return migrations.reduce((state, migration) => migration(state), appState);
}
